export default class AddAdvertise {
  constructor() {
    if (this.vars()) {
      this.setupEvents();
    }
  }

  vars() {
    this.form = document.getElementById('addAdvertise');

    if (!this.form) return;

    this.action = this.form.getAttribute('action');
    this.elements = this.form.elements;
    this.priceEl = document.getElementById('price');
    [this.submit] = this.form.querySelectorAll('button[type="submit"]');

    this.rules = {
      city: {
        rule: 'placeholder',
        message: 'Miasto jest wymagane'
      },
      subject: {
        rule: 'placeholder',
        message: 'Przedmiot jest wymagany'
      },
      education_level: {
        rule: 'required',
        message: 'Zakres materiału jest wymagany'
      },
      place: {
        rule: 'placeholder',
        message: 'Miejsce pracy jest wymagane'
      },
      online: {
        rule: 'placeholder',
        message: 'Rodzaj lekcji jest wymagany'
      },
      price: {
        rule: new RegExp("^[0-9]{1,5}$"),
        message: 'Cena jest wymagana'
      },
      price_for: {
        rule: 'required',
        message: 'Pole wymagane'
      },
      title: {
        rule: 'required',
        message: 'Tytuł jest wymagany'
      },
      content: {
        rule: 'required',
        message: 'Treść jest wymagana'
      },
    }

    this.errors = [];

    return true;
  }

  setupEvents() {
    this.form.addEventListener('submit', (evt) => this.handleSubmit(evt));
    this.priceEl.addEventListener('input', (e) => {
      this.priceEl.value = this.priceEl.value.replace(/\D/g,'');
    });
  }

  handleSubmit(evt) {
    evt.preventDefault();
    this.clearValidationErrors();

    const data = this.buildData();

    if (!this.errors.length) {
      this.send(data);
    } else {
      this.throwValidationError();
    }
  }

  buildData() {
    let data = {};
    let levels = '';

    for (let i = 0; i < this.elements.length; i++) {
      const el = this.elements[i];

      if (el.getAttribute('type') !== 'submit' && el.getAttribute('type') !== 'checkbox') {
        const key = el.getAttribute('name');
        const val = el.value;
        this.validate(key, val);
        data[key] = val;
      } else if (el.getAttribute('type') === 'checkbox' && el.getAttribute('name') == 'level-checkbox[]') {
        if (el.checked) {
          if (!levels.length) {
            levels += el.value;
          } else {
            levels += `;${el.value}`;
          }
        }
      }
    }
    this.validate('education_level', levels);
    data['education_level'] = levels;
    return data;
  }

  send(data) {
    this.submit.setAttribute('disabled', '');
    axios.post(this.action, data)
    .then((response) => {
      if (response && response.data.code === 200) {
        window.location.assign(response.data.payload.redirect);
      } else {
        throw new Error(response);
      }
      this.submit.removeAttribute('disabled');
    })
    .catch((error) => {
      document._kweber.toast({
        type: 'error',
        title: 'Błąd zapisu, spróbuj ponownie'
      });
      this.submit.removeAttribute('disabled');
    });
  }

  validate(key, val) {
    if (this.rules[key] !== undefined) {
      if (this.rules[key].rule === 'placeholder') {
        if (val === 'placeholder') {
          const error = {
            name: key,
            msg: this.rules[key].message
          };
          this.errors.push(error);
        }
      } else if (this.rules[key].rule === 'required') {
        if (!val.length) {
          const error = {
            name: key,
            msg: this.rules[key].message
          };
          this.errors.push(error);
        }
      } else if (this.rules[key].rule instanceof RegExp) {
        if (!val.match(this.rules[key].rule)) {
          const error = {
            name: key,
            msg: this.rules[key].message
          };
          this.errors.push(error);
        }
      }
    }
  }

  throwValidationError() {
    this.errors.forEach((error) => {
      let node = null;
      if (error.name === 'education_level') {
        node = document.getElementById('cbErrorNode');
      } else {
        const field = this.elements.namedItem(error.name);
        const choices = field.closest('.choices__inner');
        node = field.closest('div');

        if (choices) {
          choices.classList.add('form-invalid-right');
        } else {
          field.classList.add('form-invalid-right');
        }
      }

      node.appendChild(this.getErrorNode(error.name, error.msg));
    });
  }

  clearValidationErrors() {
    this.errors = [];
    const errorNodes = this.form.getElementsByClassName('form-error');
    const errorFields = this.form.getElementsByClassName('form-invalid-right');
    Array.from(errorNodes).forEach((node) => {
      node.remove();
    });

    Array.from(errorFields).forEach((field) => {
      field.classList.remove('form-invalid-right');
    });
  }

  getErrorNode(key, msg) {
    const label = document.createElement("label");
    label.setAttribute('for', key);
    label.classList.add('form-error');
    label.classList.add('form-invalid-right');
    label.innerText = msg;
    return label;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/AddAdvertise.js